import React, { useState } from "react";

import PaymentMethodSheet from "./PaymentMethodSheet";

const CardIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <rect x="2.4" y="4.6" width="15.2" height="10.8" rx="2.4" />
    <path d="M2.4 8.4h15.2M5.4 12.4h3" />
  </svg>
);

const PaymentMethodCard = ({ payment }) => {
  const [picking, setPicking] = useState(false);

  const method = payment.selectedMethod;

  return (
    <section className="sy-flow-card sy-checkout-payment">
      <div className="sy-flow-card-head">
        <h2 className="sy-flow-card-title">Payment method</h2>
      </div>

      <div className="sy-flow-card-body">
        <div className="sy-flow-row">
          <div className="sy-flow-row-lead">
            <span className="sy-flow-row-icon">
              <CardIcon />
            </span>

            <div className="sy-flow-row-body">
              <span className="sy-flow-row-label">Paying with</span>
              <span className={`sy-flow-row-value${method ? "" : " is-placeholder"}`}>
                {payment.isLoading ? "Loading…" : method?.title || "Choose a method"}
              </span>

              {method?.description && (
                <span className="sy-flow-hint">{method.description}</span>
              )}
            </div>
          </div>

          <button
            type="button"
            className="sy-flow-link"
            disabled={!payment.methods.length}
            onClick={() => setPicking(true)}
          >
            Change
          </button>
        </div>
      </div>

      {picking && <PaymentMethodSheet payment={payment} onClose={() => setPicking(false)} />}
    </section>
  );
};

export default PaymentMethodCard;
